export default __webpack_public_path__ + "static/media/complementary--accident-area--g1.d5411006.png";